import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_home/')({
  beforeLoad: () => {
    throw redirect({ to: '/project', replace: true });
  },
});
